

module.exports = __webpack_require__.stylable.create(
    "SubtotalRow1773828526",
    {"classes":{"root":"SubtotalRow1773828526__root","subTotalTitleText":"SubtotalRow1773828526__subTotalTitleText","subTotalTitleValue":"SubtotalRow1773828526__subTotalTitleValue","labelTextAlign":"SubtotalRow1773828526__labelTextAlign","textAlign":"SubtotalRow1773828526__textAlign"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    4,
    "SubtotalRow1773828526",
    null
);
